import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCollabarationProjects, getProjectById } from "../../../service/MainService";
import noimg from "../../../assets/images/noimg.webp";

const RelatedCollaborators = ({ userId }) => {
  const [collaborationProjects, setCollaborationProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCollaborationProjects = async () => {
      try {
        const projects = await getCollabarationProjects(userId);
        setCollaborationProjects(projects.CollaborationProjectList);
      } catch (error) {
        console.error("Error fetching collaboration projects:", error);
      }
    };

    fetchCollaborationProjects();
  }, [userId]);

  const navigateToProjectDetail = async (projectId) => {
    if (!projectId) return;
    try {
      const token = localStorage.getItem("accessToken");
      const projectDetails = await getProjectById(projectId, token);
      navigate(`/project/${projectId}`, {
        state: { projectDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  return (
    <>
      {collaborationProjects?.length > 0 && (
        <div className="lg:px-40 mt-10 mb-10">
          <div className="flex flex-col lg:flex-row items-center mb-5">
            <div className="text-3xl border-r border-gray-400 pr-4">
              Collaborations
            </div>
            <div className="text-gray-500 font-semibold pl-4">
              {collaborationProjects?.length} projects added
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mt-5">
            {collaborationProjects.map((project, index) => (
              <div
                key={index}
                className="relative cursor-pointer shadow-md"
                onClick={() =>
                  navigateToProjectDetail(
                    project.projectId || project.ProjectId
                  )
                }
              >
                <img
                  src={
                    project.image1 ||
                    project.Image1 ||
                    (project.imageUrls && project.imageUrls.length > 0
                      ? project.imageUrls[0]
                      : noimg)
                  }
                  alt={project.projectName || "Project"}
                  className="w-full h-40 sm:h-60 object-cover"
                  onError={(e) => {
                    e.target.src = noimg;
                  }}
                />
                <div className="absolute inset-0 flex flex-col gap-2 items-center opacity-0 hover:opacity-100 transition-opacity duration-300 bg-black bg-opacity-50 text-white p-2">
                  <div className="mt-5">
                    <p className="text-sm sm:text-lg font-semibold text-center">
                      {project.collaborationTypes}
                    </p>
                    <p className="text-xs sm:text-sm">{project.participants}</p>
                  </div>
                  <div className="flex flex-col items-center justify-end mt-24">
                    <p className="text-sm sm:text-lg font-semibold text-center">
                      {project.projectName}
                    </p>
                    <p className="text-xs sm:text-sm">
                      {project?.country?.countryName}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RelatedCollaborators;
